import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Button from "components/Button/Button";
import Input from "components/Form/Input";
import { useForm } from "react-hook-form";
import AuthLayout from "components/Layout/AuthLayout";
import { AuthCard } from "components/Card/AuthCard";
import actionApi from "services/actionApi";
import useAuth from "hooks/useAuth";
import makeToast from "utils/toast/makeToast";
import InputPassword from "components/Form/InputPassword";
import { useQuery } from "hooks/useQuery";

const LoginPage = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { doLogin } = useAuth();
  const { getQuery } = useQuery();
  const {
    register,
    watch,
    formState: { errors, isDirty, isValid },
    handleSubmit,
  } = useForm();
  const disabled =
    isSubmitting || !isDirty || !isValid || Object.keys(errors).length > 0;

  const handleNavigate = () => {
    const query = getQuery(location.search);
    navigate(query?.next ? query?.next : "/");
  };

  const onSubmit = async (payload) => {
    setIsSubmitting(true);
    actionApi
      .login(payload)
      .then((response) => {
        handleNavigate();
        doLogin(response?.data?.access);
      })
      .catch((err) => {
        makeToast({ label: err?.response?.data?.errors?.[0], type: "error" });
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <AuthLayout>
      <AuthCard className={"md:justify-center"}>
        <span className="text-2xl text-wce-navy font-medium mb-6 self-center">
          Login
        </span>
        <form className="flex flex-col" onSubmit={handleSubmit(onSubmit)}>
          <Input
            {...register("email", { required: true })}
            className="mb-4"
            type="email"
            placeholder="Email"
            errors={errors}
          />
          <InputPassword
            {...register("password", { required: true })}
            className="mb-4"
            placeholder="Password"
            errors={errors}
          />
          <div className="self-end mb-4 text-sm">
            <Link to="/forgot-password">
              <Button size="small" variant="link">
                Forgot Password
              </Button>
            </Link>
          </div>
          <Button
            type="submit"
            size="large"
            className="w-full mb-6 h-10"
            rounded
            disabled={disabled}
          >
            Login
          </Button>
        </form>
        <span className="self-center text-wce-neutral-7">
          Don’t have an account yet?
        </span>
        <div className="self-center">
          <Link to="/register">
            <Button variant="link" size="large">
              Register now
            </Button>
          </Link>
        </div>
      </AuthCard>
    </AuthLayout>
  );
};

export default LoginPage;
